module.exports = __webpack_public_path__ + "img/wechat-noti-tip1.88dfdbd3.jpeg";